import {
  Button, Card, Link, makeStyles, Modal, Paper, Typography,
} from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import clsx from 'clsx';
import React, { useCallback, useState } from 'react';
import {
  flashyplayerSetup64Url,
  flashyplayerSetup86Url,
  FLASHYPLAYER_LATEST_VERSION,
} from '../constants';

const DownloadButton = ({
  className,
  children,
  href,
  onClick,
}: {
  className?: string;
  href?: string;
  children: React.ReactNode;
  onClick: () => void;
}): JSX.Element => (
  <Button
    variant="contained"
    startIcon={<GetAppIcon />}
    color="primary"
    href={href}
    className={className}
    onClick={onClick}
  >
    {children}
  </Button>
);

const useStyles = makeStyles((theme) => ({
  root: {
    width: '20em',
    padding: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
  },
  title: {
    textAlign: 'center',
  },
  version: {
    marginBottom: theme.spacing(1),
  },
  secondButton: {
    marginTop: theme.spacing(1),
  },
  demoExplanation: {
    fontSize: '0.7em',
  },
  version32Link: {
    marginTop: theme.spacing(1),
    fontSize: '0.8em',
  },
  modal: {
    display: 'flex',
    alignItems: "center",
    justifyContent: "center"
  },
  messagebox: {
    textAlign: 'center',
    maxWidth: '90vw',
    padding: theme.spacing(5),
  },
  securityImg: {
    display: 'block',
    margin: 'auto',
    marginTop: theme.spacing(5),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  securityWarningText: {
    marginTop: theme.spacing(5),
  }
}));

export const DownloadBox = ({
  className,
}: {
  className?: string;
}): JSX.Element => {
  const classes = useStyles();
  const [showSecurityNotice, setShowSecurityNotice] = useState(false);

  const openSecurityNotice = useCallback(
    () => {
      setShowSecurityNotice(true);
    },
    [],
  )


  return (
    <Card className={clsx(classes.root, className)} variant="outlined">
      <Typography variant="h5" component="div" className={classes.title}>
      </Typography>
      <Typography className={classes.version}>
        Version {FLASHYPLAYER_LATEST_VERSION}
      </Typography>
      <Typography>
        <img src="/img/win7.png" title="Windows Vista / 7" alt="Windows Vista / 7" />
        <img src="/img/win10.png" title="Windows 8 / 10" alt="Windows 8 / 10" />
      </Typography>
      <DownloadButton href={flashyplayerSetup64Url} onClick={openSecurityNotice}>
        FlashyPlayer 64 bits
      </DownloadButton>
      <span className={classes.version32Link}>
        or <Link href={flashyplayerSetup86Url}  onClick={openSecurityNotice}>FlashyPlayer 32 bits</Link>.
      </span>
      <Modal
        open={showSecurityNotice}
        onClose={() => setShowSecurityNotice(false)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className={classes.modal}
      >
        <Paper className={classes.messagebox}>
          <Typography variant="h5" component="span">
            Thank you for downloading <b>FlashyPlayer</b>!
          </Typography>
          <Typography className={classes.securityWarningText}>
            Because <b>FlashyPlayer</b> is a new software, you may be prompted the following screen.
          </Typography>
          <Typography>Click on <b>More Info</b>, and then on <b>Run anyway</b>.</Typography>
          <img src="screenshots/smartscreen.png" className={classes.securityImg} alt="Security warning popup" />
        </Paper>
      </Modal>
    </Card>
  );
};
